import React from "react"
import styled from "styled-components"
// import ReactHtmlParser from 'react-html-parser';
import ExpandableContentBlock from "@airasia/phoenix-components/components/ExpandableContentBlock"


var Container = styled.div`
  color: #000000;
  padding-top: 20px;
`
export default function ExpandableContent(props) {
  return (props.title && props.description) ? (
    <Container>
        <ExpandableContentBlock
                accessible
                compressCtaText="Read less"
                ctaColor="secondary"
                ctaHoverColor="neutral"
                ctaHoverUnderlined
                ctaSize="normal"
                ctaUnderlined
                expandCtaText="Read more"
                sliceLimit={500}
                text={props.description}
                textColor="neutral"
                textType="default"
                theme="AIRASIA_CLASSIC"
                title={props.title}
                titleColor="neutral"
                titleMarginBottom="normal"
                titleType="h2"
        />
    </Container>
  ):null
}
